import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Chip } from '@mui/material';

interface Props {
  size?: 'small' | 'medium';
}

const UrgentTag: FC<Props> = ({ size = 'medium' }) => {
  const { t } = useTranslation();

  return <Chip size={size} label={t('hiring-dashboard-common:common.urgent')} color="warning" />;
};

export default UrgentTag;
